import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "m-0 h-full",
  style: {"justify-content":"space-between"}
}
const _hoisted_2 = {
  class: "flex w-full h-full",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "questionCount" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Question", -1)
const _hoisted_5 = { style: {"font-weight":"700"} }
const _hoisted_6 = { id: "currentQuestion" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"400"} }, "/", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { id: "allQuestions" }, "14", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionRating = _resolveComponent("QuestionRating")!
  const _component_StepperPanel = _resolveComponent("StepperPanel")!
  const _component_Stepper = _resolveComponent("Stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.activeQuestion - 83), 1),
          _hoisted_7,
          _hoisted_8
        ])
      ]),
      _createVNode(_component_Stepper, {
        linear: "",
        "unstyled:": "",
        true: "",
        "active-step": _ctx.activeSub,
        "onUpdate:activeStep": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeSub) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleTechnologyManagement')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 84)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "84",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 85)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "85",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 86)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "86",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 87)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "87",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 88)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "88",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleManagementSkills')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 89)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "89",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 90)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "90",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 91)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "91",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 92)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "92",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_StepperPanel, {
            header: _ctx.$tc('questionnaireForm.titleTechnicalSkills')
          }, {
            default: _withCtx(() => [
              (_ctx.activeQuestion == 93)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 0,
                    question: "93",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 94)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 1,
                    question: "94",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 95)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 2,
                    question: "95",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 96)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 3,
                    question: "96",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true),
              (_ctx.activeQuestion == 97)
                ? (_openBlock(), _createBlock(_component_QuestionRating, {
                    key: 4,
                    question: "97",
                    change: _ctx.autoSave
                  }, null, 8, ["change"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["active-step"])
    ])
  ]))
}